import { get } from "lodash-es";
import moment from "moment";
import MovimientosTablaActions from "./MovimientosTablaActions";
import { formatMonto } from "../../../lib/utils/accountingJsFns";

const formatFechaHora = (fechaHora) => {
  return moment(fechaHora).format("ddd DD/MM/YYYY H:mm");
};

export default {
  components: {
    MovimientosTablaActions,
  },
  computed: {
    rowData() {
      return this.$store.getters["Movimientos/getMovimientos"];
    },
  },
  data: () => ({
    gridApi: null,
    columnApi: null,
    gridOptions: null,
    defaultColDef: null,

    // "TABLE HEAD"
    columnDefs: [
      {
        headerName: "Fecha&Hora",
        valueGetter: (params) => {
          const Fecha = params.data.fecha;
          return formatFechaHora(Fecha);
        },
        sort: "desc",
        comparator: (valueA, valueB, nodeA, nodeB) => {
          const A = get(nodeA, "data.fecha", null);
          const B = get(nodeB, "data.fecha", null);
          return new Date(A) - new Date(B);
        },
      },
      {
        headerName: "Concepto",
        valueGetter: (params) => {
          const concepto = get(params, "data.concepto.concepto", "");
          const item = get(params, "data.concepto_item.item", "");
          return `${concepto}${item ? " - " + item : ""}`;
        },
      },
      {
        headerName: "Ingreso",
        valueGetter(params) {
          if (!parseFloat(params.data.ingreso)) {
            return "";
          } else {
            return formatMonto(params.data.ingreso, params.data.moneda);
          }
        },
        type: "numericColumn",
      },
      {
        headerName: "Egreso",
        valueGetter(params) {
          if (!parseFloat(params.data.egreso)) {
            return "";
          } else {
            return formatMonto(params.data.egreso, params.data.moneda);
          }
        },
        type: "numericColumn",
      },
      {
        headerName: "Ubicación",
        field: "ubicacion.ubicacion_dinero",
      },
      {
        headerName: "Acciones",
        cellRendererFramework: MovimientosTablaActions,
      },
    ],
  }),
  beforeMount() {
    this.gridOptions = {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.gridApi.showLoadingOverlay();

      this.$store.dispatch("Movimientos/getMovimientos").then(() => {
        this.gridApi.hideOverlay();
      });
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
};
